import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import router from './router'
import languages from './languages'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'pl',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pl',
  silentTranslationWarn: true
})

export const loadedLanguages = []

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  // If the same language and if the language was already loaded
  if (i18n.locale === lang && loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  // If the language hasn't been loaded yet
  return axios.get(`${process.env.BASE_URL}api/locales/${lang}.json`).then(
    response => {
      const messages = response.data
      i18n.setLocaleMessage(lang, messages)
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    }
  )
    .catch(error => {
      console.error(error)
      setI18nLanguage('pl')
    })
}

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  if (languages.some(element =>
    element.locale.includes(lang)
  )) {
    return loadLanguageAsync(lang).then(() => next())
  } else {
    return next('pl')
  }
})
